import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import * as styles from './FileRow.module.scss';
import { formatBytes } from '../utils/utils';

interface FileRowProps {
  title: string;
  size?: number;
  url: string;
  small?: boolean;
  noDownload?: boolean;
}

const FileRow = ({ title, size, url, small, noDownload }: FileRowProps): React.ReactElement => {
  return (
    <div className={styles.file + (small ? ' ' + styles.fileSmall : '')}>
      <span className={styles.fileTitle} title={title}>
        {title}
      </span>
      <span className={styles.fileSize}>{size !== undefined ? formatBytes(size, 0) : '---'}</span>
      <span className={styles.fileSizeDecimal}>
        {size !== undefined ? formatBytes(size, 2) : '---'}
      </span>

      <a href={url} target="_blank" rel="noopener noreferrer">
        <FontAwesomeIcon icon="external-link-alt" className={styles.icon} />
      </a>
      <a href={noDownload ? undefined : url + '?dl'}>
        <FontAwesomeIcon
          icon="download"
          className={styles.icon + (noDownload ? ' ' + styles.iconDisabled : '')}
        />
      </a>
    </div>
  );
};

export default FileRow;
